<template>
	<div class="pick-list-box">
		<div class="top-header">
			<el-button size="mini" type="primary" v-print="'#printTest'">{{$t('other.a342')}}</el-button>
		</div>
		<div id="printTest">
			<div>
			    <div class="pick-list-wrpper">
					<div class="print-area" v-if="stocklistCopy.length">
						 <div style="display: flex;justify-content: space-between;">
							 <div style="margin-bottom: 20px;">
								 <div style="display: flex;justify-content: space-between;">
									 <h2 >Picklist</h2>
								 </div>
								 <div style="font-size: 14px;font-weight: bold;padding-top: 16px;">Total: {{total}}</div>
								 <div style="font-size: 14px;font-weight: bold;padding-top: 15px;">{{nowTime}}</div> 
							 </div>
							 <div style="width: 200px;">
							 	 <img style="width: 100%;" src="../assets/img/pic/id-01.png" />
							 </div>
						 </div>
						 <div style="display: flex;justify-content: flex-start;border-bottom: 1px solid #000;font-weight: bold;" >
							 <span style="display: inline-block;width: 40px;font-size: 16px;">#</span>
							 <span style="font-size: 18px;display: inline-block;width: 115px;">Name</span>
							 <span style="font-size: 18px;display: inline-block;width: 65px;">Img</span>
							 <span style="display: inline-block;width: 120px;font-size: 16px;">P Sku</span>
							 <span style="display: inline-block;width: 98px;font-size: 16px;">W Sku</span>
							  <span style="display: inline-block;width: 125px;font-size: 16px;">variationSku</span>
							 <span style="display: inline-block;width: 90px;font-size: 16px;">Position</span>
							 <span style="font-size: 18px;">Qty</span>
						 </div>
						 <div style="display: flex;padding-bottom: 10px;border-bottom: 1px solid #000"  v-for="(item,index) in stocklistCopy">
							 <div class="desc-item">{{index+1}}</div>
							 <div class="desc-item-name">{{item.itemName}}</div>
							  <div class="pic-box"><img style="width: 100%;" :src='item.image' /></div>
							 <div class="desc-item-copy"> {{item.psku}} </div>
						    
							 <div class="desc-item-oop">
								 <div class="desc-item-bottom" v-for="(ttp,indexOne) in item.list" :key="indexOne">
									 <span  >
									    <span style="display: inline-block;width: 100px;font-size:14px;word-break: break-all;box-sizing: border-box;padding:0 5px">{{ttp.storeItem ? ttp.storeItem.skuName : ttp.variationSku}} </span>
										<span style="display: inline-block;width: 130px;font-size:14px;word-break: break-all;box-sizing: border-box;padding:0 5px">{{ttp.variationSku}} </span>
										<span style="display: inline-block;width: 92px;font-size:14px;word-break: break-all;box-sizing: border-box;padding:0 5px">{{ttp.storeItem ? ttp.storeItem.address ? ttp.storeItem.address :$t('other.a354') : $t('other.a354')}} </span>
										<span style="display: inline-block;font-size:14px;width:20px;text-align:right;">{{ttp.variationQuantityPurchased}}</span>
									 </span>
								 </div>
							 </div>
						 </div>
					</div>
					
				</div>
			
			</div>
		</div>
	</div>
</template>

<script>
	import utils from '../utils/utils'
	import api from '../api/api'
		import {
			mapState,
		     mapActions,
		} from 'vuex'
		import json2csv from 'json2csv'
		import csvExportor from "csv-export";
		export default {
		    data() {
		      return {
		        stocklist:[],
				nowTime:'',
				total:0,
				stocklistCopy:[],
			  }
		    },
			computed:{
				...mapState({
					seller: state => state.login.userInfo.userId
				}),
			
				
			},
			created(){
				this.getData()
				// this.init()
				this.getNowTime()
			},
		
			methods:{
				init(){
					let arr=JSON.parse(localStorage.getItem('stocklist'))
				    
					//获取到每个订单的items,存入newArr
					let newArr=[]
					arr.forEach(p => {
						if(p.items){
							p.items.forEach(k => {
								newArr.push(k)
							})
						}else{
							p.orderItems.forEach(k => {
								newArr.push(k)
							})
						}
						
					})
					
					//第一层
					let list=newArr.map(p => {
						return {
							itemSku:p.itemSku,
							position:p.storeItem ? p.storeItem.address : '',
							p_sku:p.storeItem ? p.storeItem.groupName : p.itemSku,
							image:p.image,
							itemName:p.itemName,
							skulist:[]
						}
					})
					console.log(list)
					 for(var i=0; i<list.length; i++){
						for(var j=i+1; j<list.length; j++){
							if(list[i].p_sku == list[j].p_sku){         //第一个等同于第二个，splice方法删除第二个
								list.splice(j,1);
								j--;
							}
						}
					}
					newArr.forEach(k => {
						list.forEach(p => {
							if(k.itemSku === p.itemSku){
								p.skulist.some(({sku}) => sku == k.variationSku ) ? '' : p.skulist.push({sku:k.variationSku,skuName:[],sku2:k.variationSku})
							}
							p.skulist.forEach(j => {
								if(k.itemSku === p.itemSku && k.variationSku === j.sku ){
									j.skuName.some(({variationName}) => variationName == k.variationName) ? '' : j.skuName.push({variationName:k.variationName,listCopy:[]})
								}
								
								j.skuName.forEach(i => {
									if(i.variationName ===k.variationName && k.itemSku === p.itemSku){
										i.listCopy.push(k)
									}
									
									i.quantity=0
									i.listCopy.forEach(h => {
										i.quantity=i.quantity + h.variationQuantityPurchased
									})
								})
							})
						})
					})

					
					
				
					let mapList=new Map()
					newArr.forEach(p => {
						let list=mapList.get(p.storeItem ? p.storeItem.groupName : p.itemSku)
						if(list == undefined) {
							list =[]
						}
						list.push(p)
						mapList.set(p.storeItem ? p.storeItem.groupName : p.itemSku,list)
					})
					
			
					mapList.forEach(value => {
						console.log(value)
						let childermapList=new Map()
						value.forEach(j => {
							let list2=childermapList.get(j.storeItem ? j.storeItem.skuName : j.variationSku)
							if(list2 == undefined) {
								list2 =[]
							}
							list2.push(j)
							childermapList.set(j.storeItem ? j.storeItem.skuName : j.variationSku,list2)
							
						})
						let arr=[]
						childermapList.forEach((value,key) => {
							
							let num=0
							value.forEach(p => {
								num+=p.variationQuantityPurchased
							})
							arr.push({
								sku:key,
								skuName:value,
								quantity:num,
								
							})
						})
						value.push(arr)
						
					})
					let list3=[]
					mapList.forEach((value,key) => {
							list3.push({
								p_sku:key,
								itemName:value[0].itemName,
								position:value[0].storeItem ? value[0].storeItem.address : '',
								image:value[0].image,
								itemSku:value[0].itemSku,
								skulist:value[value.length-1]
							})
					})
					
					this.stocklist=list3
					
				
					
				},
				getData(){
					let orderIds=JSON.parse(localStorage.getItem('stocklist'))
					api
					.getlazadaOrderByOrderId({orderIds:orderIds})
					.then(res => {
						if(res.code === 200) {
							console.log('获取到订单数据',res.data)
							res.data.forEach(p => {
										p.items=p.orderItems
										p.items.forEach(k =>{
											k.ordersn=k.orderId
											k.image=k.productMainImage,
											k.shippingCarrier=k.shipmentProvider,
											k.itemName=k.name,
											k.storeItem=JSON.parse(k.reason)
											k.itemSku=k.sku
										})
										p.ordersn=p.orderId
									})
					
							let originData=res.data
							this.getDataList(originData)
							console.log('originData',originData)
							
							
						}
					})	
				},
				getDataList(list){
					
					let arr=list
					console.log('arr',arr)
					
					
					
					

				
					let list2=[]
					let itemList=[]
					let maplist=new Map()
					arr.forEach(p => {
						p.items.forEach(k => {
							list2.push(k)
							
						})
					})

				

					let temArr=[]
					let list3=[]

					for(let i=0; i<list2.length;i++){
						if(list2[i].storeItem){
							if(temArr.indexOf(list2[i].storeItem.cusCode) ==-1){
								list3.push(list2[i])
								temArr.push(list2[i].storeItem.cusCode)
							}else{
								for(let j=0;j<list3.length;j++){
									if(list3[j].storeItem.cusCode == list2[i].storeItem.cusCode){
										
										
										list3[j].variationQuantityPurchased += list2[i].variationQuantityPurchased
										console.log(list3[j].variationQuantityPurchased)
									}
								}
							}
						}
					}
					list3.forEach(k => {
						this.total +=k.variationQuantityPurchased
					})

				

				
				
					console.log('totol2',this.total)

					list3.forEach(k => {
						k.groupId=k.storeItem ?  k.storeItem.groupId : null
							
							let list=[]
							list=maplist.get(k.groupId)
							if(list == null || list == 'undefined' || !list){
								list=[]
							}
							list.push(k)
							maplist.set(k.groupId,list)
					})




					for(let key of maplist){
						console.log(key)
						itemList.push({
							psku:key[1][0].storeItem.itemSku,
							groupId:key[0],
							image:key[1][0].image,
							itemName:key[1][0].itemName,
							list:key[1]
						})
					}





					console.log('itemList',itemList)
					console.log('maplist',maplist)
					console.log('list2',list2)
					console.log('list3',list3)


					this.stocklistCopy=itemList

					

				},
				//获取当前时间
				getNowTime(){
					let time=new Date()
					let timeCopy=utils.getCurrnetTime(time)
					this.nowTime=timeCopy
					console.log(timeCopy)
				}
			}
		  }
</script>

<style>
	
	.pick-list-box{
		width: 100%;
		background: #fff;
		z-index: 99999;
		position: absolute;
	
	}
	.top-header{
		position: relative;
		width: 800px;
		text-align: right;
		margin: 0 auto;
	
		
	}
	.pp-wrapper{
		display: flex;
	
		align-items: center;
	}
	
	.pp-name{
		display:inline-block;
		width: 300px !important;
	}
	
	.ttp-box{
		margin-bottom: 60px;
		border: 1px solid #000;
	}
	
	.pick-list-wrpper{
		width: 100%;
		display: flex;
		justify-content: center;
		font-size: 12px;
		box-sizing: border-box;
		margin: 0 10px;
	}
	
	.print-area{
		width: 210mm;
		height: 100%;
		margin-bottom: 200px;
		box-sizing: border-box;
		padding: 30px;
	}
	.print-desc{
		display: flex;
		flex: 1;
		
	}
	
	.desc-item{
		font-size: 14px;
		font-weight: bold;
		width: 100px;
		word-wrap: break-word;
	
		
	}
	.desc-item-copy{
		font-size: 14px;
		font-weight: bold;
		width: 90px;
		word-wrap: break-word;
		margin: 0 20px 0 15px;
	
		
	}
	.desc-item:nth-child(1){
		font-size: 14px;
		width: 30px;
	}
	
	.desc-item:nth-child(3){
		font-size: 14px;
		width: 600px;
	}
	
	.desc-item-ttp{
		display: inline-block;
		width: 186px;
	}
	
	.desc-item-oop{
		display: inline-block;
		
		
	}

	.desc-item-bottom{
		padding: 5px 0;
		border-bottom: 1px solid #DCDFE6
	}

	.desc-item-bottom:nth-last-child(1){
		padding: 5px 0;
		border-bottom:none
	}
	

	
	.desc-item-name{
		width: 120px;
		
	}
	
	.pic-box{
		width: 50px;
		height: 50px;
		margin: 0 5px;
	}
	
	
	
	
	
	
	
	
</style>
